import moment from 'moment';
import { getVoucherIndex } from '../../api/restApi';

export const columns = [
  { field: "id", headerName: "Sr#", width: 100 },
  { field: "code", headerName: "Code", minWidth: 150 },
  { field: "Discription", headerName: "Description", minWidth: 500 },
];

export const level3Columns = [
  { field: 'id', headerName: 'Sr#', width: 80 },
  { field: 'fullcode', headerName: 'Code', width: 200 },
  { field: "name", headerName: "Name", width: 250 },
  { field: 'type', headerName: 'TYPE', width: 200 },
  { field: 'freeze', headerName: 'FREEZE', width: 120 },
  { field: 'Discription', headerName: 'Description', width: 700 },
  // { field: "contact", headerName: "Contact", width: 250 },
  // { field: "address", headerName: "Address", width: 350 },
];

export const dialogueColumns = [
  { field: "id", headerName: "Sr#", width: 100 },
  { field: "vnumber", headerName: "Vou#", width: 140 },
  { field: "voucherDate", headerName: "Date", width: 300 },
  { field: "lock", headerName: "Lock/Unlock", width: 140 },
  { field: "amount", headerName: "Amount", width: 140 },
];

export const openingBalanceColumns = [
  { field: "id", headerName: "Sr#", width: 100 },
  { field: "fullcode", headerName: "Code", width: 140 },
  { field: "type", headerName: "Type", width: 120 },
  { field: "transactionType", headerName: "Transaction Type", width: 180 },
  // { field: "date", headerName: "Date", width: 140 },
  { field: "amount", headerName: "Amount", width: 120 },
  { field: "Discription", headerName: "Description", width: 700 },
];

export const columnsCash = [
  { field: "id", headerName: "Sr#", minWidth: 100 },
  { field: "code", headerName: "Code", minWidth: 140 },
  { field: "particular", headerName: "Particular", minWidth: 150 },
  { field: "debit", headerName: "Debit (Rs)", minWidth: 140 },
  { field: "credit", headerName: "Credit (Rs)", minWidth: 140 },
  { field: "Discription", headerName: "Description", minWidth: 150 },
];

export const columnsBank = [
  { field: "id", headerName: "Sr#", minWidth: 100 },
  { field: "code", headerName: "Code", minWidth: 140 },
  { field: "particular", headerName: "Particular", minWidth: 150 },
  { field: "cheque", headerName: "Cheque#", minWidth: 140 },
  { field: "debit", headerName: "Debit (Rs)", minWidth: 140 },
  { field: "credit", headerName: "Credit (Rs)", minWidth: 140 },
  { field: "Discription", headerName: "Description", minWidth: 150 },
];

export const columnsJournal = [
  { field: "id", headerName: "Sr#", minWidth: 100 },
  { field: "code", headerName: "Code", minWidth: 140 },
  { field: "particular", headerName: "Particular", minWidth: 150 },
  { field: "billno", headerName: "Bill/Invoice#", minWidth: 140 },
  { field: "debit", headerName: "Debit (Rs)", minWidth: 140 },
  { field: "credit", headerName: "Credit (Rs)", minWidth: 140 },
  { field: "Discription", headerName: "Description", minWidth: 150 },
];

export function GetMaxCode(dataArray) {
  let maxCode = 0;
  if (dataArray.length == 0) {
  } else {
    maxCode = Math.max.apply(
      Math,
      dataArray.map(function (o) {
        // let newcode = o.fullcode.split('-').pop();
        return parseInt(o.code);
      })
    );
  }
  return maxCode + 1;
}

export function EncodeLevel1Code(maxCode) {
  let newCode = "";
  if (maxCode < 10) {
    newCode = "0" + maxCode;
  } else {
    newCode = "" + maxCode;
  }
  return newCode;
}

export function EncodeLevel2Code(maxCode) {
  let newCode = "";
  if (maxCode < 10) {
    newCode = "00" + maxCode;
  } else if (maxCode >= 10 && maxCode < 100) {
    newCode = "0" + maxCode;
  } else {
    newCode = "" + maxCode;
  }
  return newCode;
}

export const rowBalanceText = {
  width: "14%",
  textAlign: "right",
  borderRightColor: "#90e5fc",
  borderRightWidth: 1,
  paddingRight: 3,
};

export const invoiceRowCss = {
  flexDirection: "row",
  borderBottomColor: "#bff0fd",
  borderBottomWidth: 1,
  alignItems: "center",
  justifyContent: "center",
  height: 14,
  fontSize: 8,
};

export const footerRowCssDescription = {
  width: "35%",
  textAlign: "right",
  color: "blue",
  paddingRight: 8,
};

export const allSites = [
  {
    address: "muree roead",
    city: "rwp",
    contact: "7890094884",
    id: 1,
    name: "New Site",
  },
];

export const userDetail = {
  id: "Qeu6tRI6OQdVxDFdmk0zEwrhLXp1",
  contact: "03455400000",
  active: "true",
  role: "account_manager",
  uid: "Qeu6tRI6OQdVxDFdmk0zEwrhLXp1",
  username: "03455400000@accounts.com",
};

export const footerRowCss = {
  flexDirection: "row",
  borderColor: "green",
  borderTopWidth: 1,
  borderBottomWidth: 1,
  marginTop: 20,
  alignItems: "center",
  height: 14,
  fontSize: 8,
};

export function getMonthYearFromDate(date) {
  let dateArray = date.split("/");
  return dateArray[1] + "-" + dateArray[2];
}

export async function voucherIndex(date, name) {
  var month = getMonthYearFromDate(date);
  const response = await getVoucherIndex(month, name);
  return response.date?.id ? response.date?.id : 0;
}

export function parseIntFunction(x) {
  const parsed = parseInt(x);
  if (isNaN(parsed)) {
    return 0;
  }
  return parsed;
}

export default function convertNumberToWords(amount) {
  var words = new Array();
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";
  amount = amount.toString();
  var atemp = amount.split(".");
  var number = atemp[0].split(",").join("");
  var n_length = number.length;
  var words_string = "";
  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();
    for (var i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (var i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    let value = "";
    for (var i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += words[value] + " ";
      }
      if (
        (i == 1 && value != 0) ||
        (i == 0 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Crores ";
      }
      if (
        (i == 3 && value != 0) ||
        (i == 2 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Lakhs ";
      }
      if (
        (i == 5 && value != 0) ||
        (i == 4 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Thousand ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "Hundred and ";
      } else if (i == 6 && value != 0) {
        words_string += "Hundred ";
      }
    }
    words_string = words_string.split("  ").join(" ");
  }
  return "Rupees " + words_string + " only";
}

export function getMonthsRange(startDate, endDate) {
  let endDateMoment = moment(endDate);
  let startDateMoment = moment(startDate);
  var result = [];
  if (endDateMoment.isBefore(startDateMoment)) {
    return [];
  }
  if (startDateMoment.isSame(endDateMoment, "day")) {
    result.push(startDateMoment.format("MM-YYYY"));
  } else {
    while (startDateMoment.isBefore(endDateMoment)) {
      result.push(startDateMoment.format("MM-YYYY"));
      startDateMoment.add(1, "month");
      startDateMoment.set("date", 1);
    }
  }
  return result;
}

export async function getVoucher(
  companyid,
  voucherDate,
  voucherNumber,
  voucherType
) {
  let voucherMonth = getMonthYearFromDate(voucherDate);
}

export async function deleteDocuments(documentArray) {
  const result = await Promise.all(documentArray.map(async function (item) {}));
  return result;
}

export function calculateOpeningBalance(vouchers, date) {
  let credit = 0;
  let debit = 0;
  vouchers.forEach((data) => {
    if (date.isAfter(moment(data.voucherDate, "DD-MM-YYYY"), "day")) {
      if (data.transactionType === "Credit") {
        credit = credit + parseInt(data.amount);
      } else {
        debit = debit + parseInt(data.amount);
      }
    } else {
    }
  });
  return [credit, debit];
}

export function getTodayVouchers(vouchers, date, type) {
  let credit = 0;
  let debit = 0;
  let voucherArray = [];
  vouchers.forEach((data) => {
    if (date.isSame(moment(data.voucherDate, "DD-MM-YYYY"), "day")) {
      voucherArray.push(data);
      if (data.transactionType === "Credit") {
        credit = credit + parseInt(data.amount);
      } else {
        debit = debit + parseInt(data.amount);
      }
    }
  });
  return [credit, debit, voucherArray];
}

export function calculateDebitCredit(vouchers) {
  let credit = 0;
  let debit = 0;

  vouchers.forEach((data) => {
    if (data.transactionType === "Credit") {
      credit = credit + parseInt(data.amount);
    } else {
      debit = debit + parseInt(data.amount);
    }
  });
  return [credit, debit];
}
export function getNameFromFullCode(fullcode, dataArray) {
  return dataArray.find((data) => data.fullcode === fullcode).name;
}
